import { fetchAuthenticatedJson } from './authenticatedFetch';

function buildQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }
    query.set(key, value);
  });
  const queryString = query.toString();
  return queryString ? `?${queryString}` : '';
}

export function fetchPatternScannerPageViews(filters = {}) {
  return fetchAuthenticatedJson(`/api/admin/pattern-scanner-page-views${buildQuery(filters)}`);
}